export enum FollowUpStudySection {
	Report = "REPORT",
	LegalBases = "LEGAL_BASES",
	LegalAnalysis = "LEGAL_ANALYSIS",
	Recommendation = "RECOMMENDATION",
}
